var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingZone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 4c0-1.1.9-2 2-2h3v2H4v3H2V4ZM4 22c-1.1 0-2-.9-2-2v-3h2v3h3v2H4ZM22 20c0 1.1-.9 2-2 2h-3v-2h3v-3h2v3ZM20 2c1.1 0 2 .9 2 2v3h-2V4h-3V2h3Z",
  fill: "#191C29",
  fillOpacity: 0.54
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 7h5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3v3H9V7Zm2 5h3V9h-3v3Z",
  fill: "#191C29",
  fillOpacity: 0.54
})));
export default SvgParkingZone;